<template>
  <div class="main">
    <!-- <back title="学费"></back> -->
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/tuition/banner.jpg"
    ></landingBanner>
    <div class="content">
      <div class="content-1">
        <indexTitle title1="填写联系电话获取学费报价" title2="To get the tuition" color="#a9161c"></indexTitle>
        <footerForm color="#fff" bag="#a9161c" words="获取学费"></footerForm>
        <indexTitle title1="专业不同 费用不同" title2="建议一对一在线咨询课程学费" color="#a9161c"></indexTitle>
        <div class="part1">
          <div class="part1-one">
            <router-link to="chat">
              <van-image
                src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/tuition/part1-1.png"
              >
                <template v-slot:loading>
                  <van-loading size="20" color="#fff" />
                </template>
              </van-image>
            </router-link>
          </div>
          <div class="part1-one">
            <router-link to="chat">
              <van-image
                src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/tuition/part1-2.png"
              >
                <template v-slot:loading>
                  <van-loading size="20" color="#fff" />
                </template>
              </van-image>
            </router-link>
          </div>
          <div class="part1-one">
            <router-link to="chat">
              <van-image
                src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/tuition/part1-3.png"
              >
                <template v-slot:loading>
                  <van-loading size="20" color="#fff" />
                </template>
              </van-image>
            </router-link>
          </div>
          <div class="part1-one">
            <router-link to="chat">
              <van-image
                src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/tuition/part1-4.png"
              >
                <template v-slot:loading>
                  <van-loading size="20" color="#fff" />
                </template>
              </van-image>
            </router-link>
          </div>
        </div>
      </div>
      <div class="content-2">
        <div class="part2">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/tuition/part2.jpg"
          />
        </div>
        <div class="part2-one">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/tuition/part2-1.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </div>
        <div style="width:100%;height:20px;"></div>
        <div class="part2-one">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/tuition/part2-2.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </div>
        <find2></find2>
        <div style="width:100%;height:35px;"></div>
        <div class="part2-one" style="margin-bottom:-19px;">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/tuition/part2-3.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </div>
        <find2></find2>
        <div style="width:100%;height:35px;"></div>
        <div class="part2-one">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/tuition/part2-4.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </div>
        <div style="width:100%;height:20px;"></div>
        <div class="part2-one">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/tuition/part2-5.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </div>
        <find2></find2>
        <div style="width:100%;height:35px;"></div>
        <div class="part2-one">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/tuition/part2-6.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </div>
        <div style="width:100%;height:20px;"></div>
        <div class="part2-one">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/tuition/part2-7.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </div>
        <indexTitle title1="填写联系电话获取学费报价" title2="To get the tuition" color="#a9161c"></indexTitle>
        <footerForm color="#fff" bag="#a9161c" words="点击获取学费报价"></footerForm>
      </div>
    </div>
    <div class="h25px" style="width:100%;height:25px;"></div>
    <foot></foot>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  components: {
    back: () => import("../../../components/head/back"),
    landingBanner: () => import("../../../components/common/landing-banner"),
    foot: () => import("@/components/foot/foot"),
    find2: () => import("@/components/common/find2"),
    indexTitle: () => import("@/components/common/indexTitle"),
    footerForm: () => import("@/components/form/footerForm")
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
body {
  background-color: #fff;
}
.main {
  /* margin-top: 50px; */
}

.content-1 {
  margin-top: -5px;
  /* background-image: url("https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/tuition/back.jpg"); */
  background: #fff;
}
.content-2 {
  background: #fff;
  padding: 10px;
}
.part1 {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px;
  background: #eee;
}
.part1-one {
  margin-bottom: 6px;
  width: 48.5%;
}
.part2 {
  width: 100%;
  padding: 10px;
  margin-bottom: 30px;
  margin-top: 20px;
}
.part2-one {
  width: 100%;
  margin-bottom: 40px;
}
</style>